import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import mapOmg from "../../src/assets/shopping.png"
import location from "../assets/images/mapLocation.svg"
const MapComponent = (props) => {

    const {
        lat,
        long,
        address,
        handleData,
        isDragable = true,
        showSearch = true,
        showPopUp = true,
        icon = location,
        label="Search for an address..."
    } = props

console.log('ltlng---', lat, long)
    const defaultPosition = [19.887087, 75.368714];

    const [markerPosition, setMarkerPosition] = useState([
        lat || defaultPosition[0],
        long || defaultPosition[1],
    ]);

    useEffect(() => {
        if (lat && long) {
            setMarkerPosition([lat, long])
        }

    }, [lat, long])



    const [searchAddress, setSearchAddress] = useState(address || "");
    const [suggestions, setSuggestions] = useState([]);
    const [isSearch, setIsSearch] = useState(false)


    const shopIcon = new L.Icon({
        iconUrl: icon,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -40],
    });


    const MoveMap = ({ position }) => {
        const map = useMap();




        useEffect(() => {
            if (position && !isNaN(position[0]) && !isNaN(position[1])) {


                map.flyTo(position, 15, { animate: true, duration: 1.5 }); // Smooth transition

            }
        }, [position, map]);

        return null;
    };



    useEffect(() => {

        let timer = setTimeout(() => {
            if (searchAddress.length > 3 && isSearch) {

                fetch(
                    `https://nominatim.openstreetmap.org/search?format=json&q=${searchAddress}`
                ).then((res) => {

                    return res?.json()

                }).then((data) => {

                    setSuggestions(data)

                })

            } else {
                setSuggestions([])
            }
        }, 300)

        return () => clearTimeout(timer)

    }, [searchAddress])




    return (
        <div className="">
            {
                showSearch && <>
                    {/* Address Search Input */}
                    <input
                        type="text"
                        className="date-label-input tasKCategory1 mb-4"
                        placeholder={label }
                        value={searchAddress}
                        onChange={(e) => {
                            setIsSearch(true)

                            setSearchAddress(e.target.value)

                        }}

                        onBlur={() => {
                            setTimeout(() => setSuggestions([]), 200)
                        }}

                    />

                    {/* Suggestions List */}
                    {suggestions.length > 0 && (
                        <ul className="list-group">
                            {suggestions.map((item, index) => (
                                <li
                                    key={index}
                                    className="list-group-item list-group-item-action"

                                    style={{ cursor: "pointer" }}
                                    onClick={() => {

                                        setIsSearch(false)
                                        handleData(item)
                                        setSearchAddress(item?.display_name)

                                        setTimeout(() => setSuggestions([]), 2000)
                                    }}
                                >
                                    {item?.display_name}
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            }


            <MapContainer center={markerPosition} zoom={80} style={{ height: "500px", width: "100%", borderRadius: '15px' }}>
                {
                    markerPosition && markerPosition[0] && markerPosition[1] && <MoveMap position={markerPosition} />
                }

                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker
                    position={markerPosition}
                    draggable={isDragable}
                    icon={shopIcon}
                    eventHandlers={{
                        dragend: async (e) => {
                            const { lat, lng } = e.target.getLatLng();
                            setMarkerPosition([lat, lng]);
                            fetch(
                                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
                            ).then((res) => {
                                return res?.json()
                            }).then((data) => {
                                handleData(data)
                                setSearchAddress(data?.display_name)
                            })

                            setSuggestions([])

                        },
                    }}
                >
                    {
                        showPopUp && <Popup>{searchAddress}</Popup>
                    }

                </Marker>
            </MapContainer>



        </div>
    );
};

export default MapComponent;
